export const formatDate = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso.length === 10 ? `${iso}T00:00:00` : iso);
  return d.toLocaleDateString("cs-CZ", { day: "numeric", month: "numeric", year: "numeric" });
};

export const formatDateTime = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso.length === 10 ? `${iso}T00:00:00` : iso);
  return d.toLocaleString("cs-CZ", { day: "numeric", month: "numeric", year: "numeric", hour: "2-digit", minute: "2-digit" });
};

export const formatApiError = (detail) => {
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || "").filter(Boolean).join(" ");
  return "Něco se nepodařilo. Zkuste to prosím znovu.";
};

export const inputCls = "bg-white border border-[#E5E5E5] focus:border-[#B69A58] outline-none py-3 px-4 w-full text-base transition-colors duration-300 rounded-none";

export const STATUS_LABELS = {
  nova: "Nová",
  ceka_na_termin: "Čeká na termín",
  pripravit_nabidku: "Připravit nabídku",
  kontaktovano: "Kontaktováno",
  uzavreno: "Uzavřeno",
  nezajem: "Nezájem",
};

export const STATUS_BADGE = {
  nova: "bg-[#FAF6EC] text-[#8A6D2F]",
  ceka_na_termin: "bg-[#F5F5F5] text-[#4A4A4A]",
  pripravit_nabidku: "bg-[#FAF6EC] text-[#8A6D2F]",
  kontaktovano: "bg-[#F5F5F5] text-[#4A4A4A]",
  uzavreno: "bg-[#F5F5F5] text-[#737373]",
  nezajem: "bg-[#F5F5F5] text-[#A3A3A3]",
};

export const downloadCsv = async (url, filename, token, onAuthFail, onError) => {
  try {
    const res = await fetch(url, { headers: { Authorization: `Bearer ${token}` } });
    if (res.status === 401 || res.status === 403) return onAuthFail();
    const blob = await res.blob();
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    link.click();
    URL.revokeObjectURL(link.href);
  } catch {
    onError();
  }
};
